export const PROJECT_PHASE = {
  NOMINATION: 'NOMINATION',
  VOTING: 'VOTING',
  WINNERS: 'WINNERS'
}

/**
 * Modify this variable to change the project's phase
 * @type {string}
 */
export const CURRENT_PROJECT_PHASE = PROJECT_PHASE.VOTING
